module.exports = __webpack_public_path__ + "img/9788972978534.acd2613b.jpg";